import { Link } from "react-router-dom";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import * as cartActions from "../../../store/action/cart";
import { defaultProductImage } from "../../../utils/Constants";
import { toastMessage } from "../../../utils/Message";
import { useCartFetch } from "../../../hooks/useCartFetch";
import BtnLoader from "../../BtnLoader";
import { FaCartPlus } from "react-icons/fa";
import ProductModal from "../../modal/ProductModal";
import Carousel from "react-multi-carousel";
import { responsive } from "../../../data/dummyData";
import "react-multi-carousel/lib/styles.css";
import CityModal from "../../modal/CityModal";

function CategoryProducts({ categoryName, categoryProducts }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoader, setIsLoader] = useState(0);
  const [cityModal, setCityModal] = useState(false);
  const [showClose, setShowClose] = useState(false);
  const [productModalOpen, setProductModalOpen] = useState(false);
  const [productSlug, setProductSlug] = useState("");
  const [productId, setProductId] = useState("");

  const { storeCity } = useSelector((state) => state.auth);
  useCartFetch(storeCity);

  const cartAdd = async (product_id, vendor_id, isVariant, slug) => {
    if (isVariant === "YES") {
      setProductModalOpen(true);
      setProductId(product_id);
      setProductSlug(slug);
      return false;
    }

    if (!storeCity) {
      setCityModal(true);
      return false;
    }

    setIsLoader(product_id);
    try {
      await dispatch(cartActions.cartAdd(product_id, "", ""));
      setIsLoader(0);
      toastMessage(
        "Product successfully added to cart",
        "success",
        "top-center",
        2000
      );
      navigate(`/seller-product-list/${vendor_id}`);
    } catch (e) {
      toastMessage(e.message, "danger", "top-center", 5000);
      setIsLoader(0);
    }
  };

  return (
    <>
      {/*<ProductModal*/}
      {/*  productModalOpen={productModalOpen}*/}
      {/*  setProductModalOpen={setProductModalOpen}*/}
      {/*  slug={productSlug}*/}
      {/*  queryProductId={productId}*/}
      {/*/>*/}

      <CityModal
        cityModal={cityModal}
        setCityModal={setCityModal}
        showClose={showClose}
      />
      <section className="hot-deals pt-10 overflow-hidden">
        <div className="container container-lg">
          <div className="row g-12">
            <div className="col-md-12 mt-10">
              <div
                className="section-heading m-0 p-10"
                style={{ backgroundColor: "#f8f9fa" }}>
                <div className="flex-between flex-wrap gap-8">
                  <h5 className="mb-0 wow bounceInLeft">{categoryName}</h5>
                  <div className="flex-align gap-16 wow bounceInRight">
                    <Link
                      to="#"
                      className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline">
                      View All
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-0">
              <div className={`list-grid-wrapper`}>
                <Carousel
                  swipeable={false}
                  draggable={false}
                  showDots={false}
                  responsive={responsive}
                  ssr={true}
                  autoPlay={false}
                  autoPlaySpeed={5000}
                  keyBoardControl={true}
                  customTransition="all .5"
                  transitionDuration={500}
                  containerclassName="carousel-container"
                  removeArrowOnDeviceType={["tablet", "mobile"]}
                  deviceType={"desktop"}
                  dotListclassName="custom-dot-list-style"
                  itemclassName="carousel-item-margin-10-px">
                  {categoryProducts.map((proData, index) => (
                    <div
                      className="product-card w-100  hover-border-main-600 position-relative transition-2"
                      key={proData.id}>
                      <div className="card h-100 w-100 rounded-0">
                        <div
                          className="card-img-container position-relative"
                          style={{
                            height: window.innerWidth < 576 ? "150px" : "180px",
                          }}>
                          <Link
                            to={`/product-details/${proData.product_slug}?product_id=${proData.id}`}
                            className="d-flex h-100 bg-light align-items-center justify-content-center">
                            <img
                              src={
                                proData.first_image_url || defaultProductImage
                              }
                              alt={proData.product_name}
                              className="img-fluid mh-100 mw-100 p-2"
                              style={{
                                maxHeight: "100%",
                                maxWidth: "100%",
                                objectFit: "contain",
                              }}
                              onError={(e) => {
                                e.target.src = defaultProductImage;
                              }}
                            />
                          </Link>
                          {proData.discount > 0 && (
                            <span className="badge bg-danger position-absolute top-0 start-0 m-2">
                              {proData.discount}% OFF
                            </span>
                          )}
                          <span className="badge bg-warning text-dark text-sm moq position-absolute bottom-0 end-0 m-2">
                            MOQ: {proData.min_sale_qty}
                          </span>
                        </div>

                        <div
                          className="card-body d-flex flex-column"
                          style={{ minHeight: "180px" }}>
                          <p
                            className="text-md"
                            style={{ color: "#dc3545", fontWeight: "700" }}>
                            {proData.brand_name || "NA"}
                          </p>
                          <div className="small mb-1 codeandmoq">
                            <span className="text-muted text-sm">
                              #{proData.product_code}
                            </span>
                            &nbsp;&nbsp;&nbsp;
                          </div>

                          <h6
                            className="card-title mb-2 fs-6 text-truncate-2 flex-grow-0 text-sm"
                            title={proData.product_name}>
                            <Link
                              to={`/product-details/${proData.product_slug}?product_id=${proData.id}`}
                              className="text-dark text-decoration-none"
                              style={{ minHeight: "120px" }}>
                              {proData.product_name}
                            </Link>
                          </h6>

                          <div className="price-container mb-2 flex-grow-0">
                            <div className="text-center">
                              <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through d-block">
                                MRP : {proData.mrp}
                              </span>
                              <span className="text-heading text-md fw-semibold">
                                Rs.{" "}
                                {Number(proData?.selling_price || 0).toFixed(2)}{" "}
                                <span className="text-gray-500 fw-normal">
                                  /Per Pc
                                </span>{" "}
                              </span>
                            </div>
                          </div>

                          {proData.stock_status === "AVAILABLE" ? (
                            <button
                              className={`btn btn-sm mt-auto w-100 ${
                                isLoader === proData.id
                                  ? "btn-secondary"
                                  : "btn-success"
                              }`}
                              disabled={isLoader === proData.id}
                              onClick={() =>
                                cartAdd(
                                  proData.id,
                                  proData.seller,
                                  proData.isVariant,
                                  proData.product_slug
                                )
                              }
                              style={{
                                whiteSpace: "nowrap",
                                padding: "0.25rem 0.5rem",
                                fontSize: "0.875rem",
                              }}>
                              {isLoader === proData.id ? (
                                <BtnLoader />
                              ) : (
                                <>
                                  <FaCartPlus className="me-1" /> Add to Cart
                                </>
                              )}
                            </button>
                          ) : (
                            <button
                              className="btn btn-sm btn-danger w-100 mt-auto"
                              disabled>
                              Out of Stock
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CategoryProducts;
